import React, { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useModal } from '../../hooks/use-modal';
import Global from '../../store/global-selectors';
import { PhoneVerify } from '../phone-verify';
import { PhoneVerificationSubject } from './phone-verificiation-subject';

export const PhoneVerificationContext = createContext();

export const PhoneVerificationContextProvider = ({ children }) => {
  const [providerIdRequiringPhoneVerification, setProviderIdRequiringPhoneVerification] = useState();
  const { open, isOpen, close: closePhoneVerification } = useModal();
  const sellerId = useSelector(Global.selectSellerSellerId);

  useEffect(() => {
    const subscription = PhoneVerificationSubject.subscribe(({ sellerLabelProviderId }) => {
      setProviderIdRequiringPhoneVerification(sellerLabelProviderId);
      if (sellerLabelProviderId > 0) {
        open();
      }
    });
    return () => subscription.unsubscribe();
  }, [open, setProviderIdRequiringPhoneVerification]);
  const data = {
    providerIdRequiringPhoneVerification,
  };
  return (
    <PhoneVerificationContext.Provider value={data}>
      {children}
      {isOpen && (
        <PhoneVerify
          close={closePhoneVerification}
          sellerId={sellerId}
          sellerLabelProviderId={providerIdRequiringPhoneVerification}
          setVerification={setProviderIdRequiringPhoneVerification}
        />
      )}
    </PhoneVerificationContext.Provider>
  );
};

PhoneVerificationContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
